import type { ThemeAssetReference } from '../theme-contract/types';
import type { ChannelThemeAssetDto, ChannelThemeDto, ChannelThemeWriteRequestDto } from './channel-themes.api.types';
import type { AccountTheme, CreateChannelThemeArgs, UpdateChannelThemeArgs } from './types';

export function toApiChannelThemesUrl(accountId: string) {
  return `/v2/accounts/${accountId}/channel_themes`;
}

export function toApiChannelThemeUrl(accountId: string, themeId: string, action: 'clone' | 'delete' | 'update') {
  return `${toApiChannelThemesUrl(accountId)}/${themeId}/${action}`;
}

export function toApiChannelThemeAssetUploadUrl(accountId: string) {
  return `${toApiChannelThemesUrl(accountId)}/direct_upload`;
}

export function toApiChannelThemeAssetUpload(file: File): FormData {
  const formData = new FormData();

  formData.append('file', file);

  return formData;
}

// The upload result goes into the theme document's image field as is; its snake_case is the API's image contract.
export function fromApiChannelThemeAsset({
  asset,
  blob_id,
  file_name,
  url,
}: ChannelThemeAssetDto): ThemeAssetReference {
  return { asset, blob_id, file_name, url };
}

export function fromApiChannelTheme({ id, meta, name }: ChannelThemeDto): AccountTheme {
  return { id, name, theme: meta };
}

export function toApiChannelThemeWrite({
  name,
  theme,
}: Pick<CreateChannelThemeArgs | UpdateChannelThemeArgs, 'name' | 'theme'>): ChannelThemeWriteRequestDto {
  return {
    ...(name === undefined ? {} : { name }),
    ...(theme === undefined ? {} : { meta: theme }),
  };
}
